module.exports = __webpack_public_path__ + "img/f-thermometer-img7-2.59314ae3.jpg";